import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { BtnComponent } from '../../components/button';
import SpeechMic from '../../components/mic';
import { TextAreaField } from '../../components/reactHookFormFields/textAreaFields';
import { useGroupChatContext } from '../../context/groupchatContext';
import { useCreatePaDocumateThreadMutation, useSpeechToTextMutation } from '../../services/chatService';


const ChangeDetailsForm = React.memo(({onStartBotChat}) => {

    const groupChatContext = useGroupChatContext();
    const {authData, selectedChat} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat
    }));

    const {
        handleSubmit,
        getValues,
        setValue,
        control,
        formState: { errors },
    } = useForm({defaultValues: {}});

    const [createPaDocumateThread, {isLoading}] = useCreatePaDocumateThreadMutation();
    const onSubmitForm = async(values) => {
        const payload = {location_id: selectedChat?.location?.uuid, pid: selectedChat.pid, nurse_id: authData?.id}
        createPaDocumateThread(payload).then((res) => {
            if(res.data?.thread_id){
                onStartBotChat({...values, thread_id: res.data.thread_id})
            }
            else {
                toast.error(res?.data?.msg);
            }
        });
    }

    const onSpeechAvailable = (text) =>{
        const descriptionVal = getValues('description');
        const finalText = ((descriptionVal ? descriptionVal : '')+' '+text).trim()
        setValue('description', finalText)
    }


    return(
        <form id="change_detail_form" onSubmit={handleSubmit(onSubmitForm)}>
            <div className="mb-6 mt-2 relative">
                <SpeechMic transformSpeech={onSpeechAvailable} />
                <TextAreaField
                    name="description"
                    title="Describe"
                    // data-audio-enabled={"true"}
                    rows="4"
                    control={control}
                    rules={{
                        required: {value: true},
                    }}
                    errors={errors}
                />
            </div>
            <BtnComponent text="Start Chat!" btnType='primary_theme' form="change_detail_form" type="submit" loading={isLoading} className={`px-4 text-[18px] w-[15rem] text-center justify-center mx-auto`} />
        </form>
    )
})

export default ChangeDetailsForm;